import { render, staticRenderFns } from "./chatgpt.vue?vue&type=template&id=13bcd960"
import script from "./chatgpt.vue?vue&type=script&lang=js"
export * from "./chatgpt.vue?vue&type=script&lang=js"
import style0 from "./chatgpt.vue?vue&type=style&index=0&id=13bcd960&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports